import { render } from "./HosPalPatientDetails.vue?vue&type=template&id=4ba90330&ts=true"
import script from "./HosPalPatientDetails.ts?vue&type=script&lang=ts&external"
export * from "./HosPalPatientDetails.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__